$(document).ready(function () {
    'use strict';

    $('.js_personalisedFormOverlay').mtcOverlay({
        buttonHtml: '<div class="altCloseButton overlayCloseButton"><a href="#"><img class="enquireCloseSVG" src="/sites/petervardy/images/svgs/enquire-times-regular.svg" alt="Close Popup" /> Close</a></div>'
    });
});